export { v4 as uuid } from '@lukeed/uuid';
//# sourceMappingURL=uuid.js.map